import { BlinkingHighlight } from 'chessboard/plugins/blinking-highlight/config/types';
import { Core } from 'chessboard/core/config/types';
import { is } from 'utils/app/model/is';
import type { Plugins } from 'chessboard/core/plugins/config/types';

/**
 * Convert a BlinkHighlight API event into a command.
 */
export function createBlinkingHighlightPlugin(): Plugins.Model {
  return {
    match: [
      {
        condition: is(Core.APIEvents.BlinkHighlight),
        handler: blinkHighlight,
      },
    ],
    name: BlinkingHighlight.Plugin.Name,
  };

  /**
   * Blink the highlight.
   */
  function blinkHighlight(event: Core.Event, context: Core.Context) {
    const { renderer } = context;

    renderer?.blinkHighlights(event.data, context);
  }
}
